"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _adminQuery = require("@/apollo/queries/admin-query");
var state = {
  admin: {},
  admins: [],
  adminsAggregate: [],
  totalCount: 0
};
var mutations = {
  UPDATE_ADMIN: function UPDATE_ADMIN(state, admin) {
    state.admin = admin.map(function (admin) {
      return admin;
    });
  },
  UPDATE_ADMINS: function UPDATE_ADMINS(state, admins) {
    state.admins = admins.map(function (admin) {
      return admin;
    });
  },
  UPDATE_ADMINS_AGGREGATE: function UPDATE_ADMINS_AGGREGATE(state, admins) {
    state.adminsAggregate = admins.admin.map(function (admin) {
      return admin;
    });
  },
  SET_ADMIN_TOTAL_COUNT: function SET_ADMIN_TOTAL_COUNT(state, total) {
    state.totalCount = total;
  }
};
var actions = {
  fetchAdmin: function () {
    var _fetchAdmin = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 1;
            return _apolloClient.apolloClient.query({
              query: _adminQuery.ADMIN_QUERY,
              variables: {
                id: id
              }
            });
          case 1:
            res = _context.sent;
            commit('UPDATE_ADMIN', res.data.admin);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetchAdmin(_x, _x2) {
      return _fetchAdmin.apply(this, arguments);
    }
    return fetchAdmin;
  }(),
  fetchAdmins: function () {
    var _fetchAdmins = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            _context2.next = 1;
            return _apolloClient.apolloClient.query({
              query: _adminQuery.ADMINS_LIST_QUERY
            });
          case 1:
            res = _context2.sent;
            commit('UPDATE_ADMINS', res.data.admin);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function fetchAdmins(_x3) {
      return _fetchAdmins.apply(this, arguments);
    }
    return fetchAdmins;
  }(),
  fetchAdminsAggregate: function () {
    var _fetchAdminsAggregate = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, page) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            _context3.next = 1;
            return _apolloClient.apolloClient.query({
              query: _adminQuery.ADMINS_LIST_WITH_AGGREGATE_QUERY,
              variables: {
                limit: 1,
                offset: page
              }
            });
          case 1:
            res = _context3.sent;
            commit('UPDATE_ADMINS_AGGREGATE', res.data);
            commit('SET_ADMIN_TOTAL_COUNT', res.data.admin_aggregate.aggregate.count);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function fetchAdminsAggregate(_x4, _x5) {
      return _fetchAdminsAggregate.apply(this, arguments);
    }
    return fetchAdminsAggregate;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};